import './App.css';
import './Styles/Navbar.css';
import './Styles/mainpage.css';
import './Styles/products.css';
import './Styles/Form.css';
import './Styles/courses.css';
import './Styles/contact.css';
 
 
 
import React, { useState } from 'react';
import Navbar from './Navbar';
import Carousel from './Carousel';
import Products from './Products';
import ProductsK from './ProductsK';
import ProductsC from './ProductsC';
import Forms from './Forms';
import Footer from './Footer';
import Contact from './Contact';
import About from './about';
import Feedback from './FeedForm';
import WorkshopRegistration from './WorkshopRegistration';
 

import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import Courses from './Courses';
import AddProductPage from './AddProductPage';

// Initial products data for shared state
const initialProducts = [
  { 
    id: 1, 
    name: 'Sunflower Stitch', 
    price: 199, 
    image: require('./imgs/sunflower.png'),
    description: 'Beautiful hand-embroidered sunflower design',
    category: 'Embroidery'
  },
  { 
    id: 2, 
    name: 'Turtles', 
    price: 550, 
    image: require('./imgs/turtle.png'),
    description: 'Cute crochet turtle set',
    category: 'Crochet'
  },
  { 
    id: 3, 
    name: 'Roses', 
    price: 450, 
    image: require('./imgs/rose.png'),
    description: 'Elegant embroidered rose pattern',
    category: 'Embroidery'
  },
  { 
    id: 4, 
    name: 'Elephant', 
    price: 1150, 
    image: require('./imgs/elephant.jpeg'),
    description: 'Detailed knitted elephant design',
    category: 'Knitting'
  },
  { 
    id: 5, 
    name: 'Denim Bags', 
    price: 1250, 
    image: require('./imgs/bags.png'),
    description: 'Handcrafted embroidered denim bags',
    category: 'Embroidery'
  }
];

// Authentication removed: all routes are public now

function App() {
  const [mode, setMode] = useState('light');
  
  const [products, setProducts] = useState(initialProducts);

  

  const toggleMode = () => {
    if (mode === 'light') {
      setMode('dark');
      document.body.style.backgroundColor = 'black';
    } else {
      setMode('light');
      document.body.style.backgroundColor = 'white';
    }
  };

  return (
    <>
      <Router>
        <Navbar 
          mode={mode} 
          toggleMode={toggleMode} 
        />
        <Routes>
          <Route path="/" element={<Carousel mode={mode} />} />
          <Route path="/courses" element={<Courses mode={mode} />} />
          <Route path="/products" element={<Products products={products} setProducts={setProducts} />} />
          <Route path="/addproduct" element={<AddProductPage setProducts={setProducts} products={products} />} />
          <Route path="/productsK" element={<ProductsK />} />
          <Route path="/productsC" element={<ProductsC />} />
          <Route path="/form" element={<Forms />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/feed" element={<Feedback />} />
          <Route path="/workshop-registration" element={<WorkshopRegistration />} />
        </Routes>
        <Footer />
      </Router>
    </>
  );
}

export default App;
